import { render, staticRenderFns } from "./HotList.vue?vue&type=template&id=1b1029d4&scoped=true"
import script from "./HotList.vue?vue&type=script&lang=js"
export * from "./HotList.vue?vue&type=script&lang=js"
import style0 from "./HotList.vue?vue&type=style&index=0&id=1b1029d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1029d4",
  null
  
)

export default component.exports